import moment from "moment"
import React, { useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native"
import { enumerateDaysBetweenDates, getDay, getDayFirstLetter } from "@Utils/utils"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"

moment.locale("fr")

const { width } = Dimensions.get("screen")
export const CustomCalendar = (props) => {
    const today = new Date()
    const week = enumerateDaysBetweenDates(today, moment(today).add(7, "day"))
    const [selectedDay, setSelectedDay] = useState(getDay(week[0]))

    const DayComponent = ({ date }) => {
        const dayFLetter = getDayFirstLetter(date)
        const dayNumber = moment(date).format("D")
        const selected = selectedDay == dayNumber
        const color = selected ? baseColors.green.primary : baseColors.grey

        return (
            <TouchableOpacity
                disabled={props.disabled}
                onPress={() => {
                    setSelectedDay(dayNumber)
                    props.handleChange?.(date)
                }}
                style={{ flex: 1, flexDirection: "column", padding: 10, alignContent: "center", alignItems: "center" }}
            >
                <View>
                    <OpenSansText textAlign={"center"} fontSize={16} color={color}>
                        {dayFLetter}
                    </OpenSansText>
                    <Spacer height={5} />
                    <OpenSansText textAlign={"center"} fontSize={16} fontWeight={"bold"} color={color}>
                        {dayNumber}
                    </OpenSansText>
                    {selected && <View style={styles.dot}></View>}
                </View>
            </TouchableOpacity>
        )
    }
    return (
        <View style={{ width: width - 40 }}>
            <TouchableOpacity
                onPress={() => {
                    setSelectedDay(getDay(new Date()))
                    props.handleChange?.(new Date())
                }}
            >
                <OpenSansText
                    style={{ marginLeft: 10 }}
                    fontWeight={"bold"}
                    fontSize={14}
                    color={baseColors.green.primary}
                >
                    AUJOURD'HUI
                </OpenSansText>
            </TouchableOpacity>
            <View style={{ flexDirection: "row" }}>
                {week.map((day, i) => (
                    <DayComponent date={day} key={i} />
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    dot: {
        borderRadius: 10,
        alignSelf: "center",
        marginTop: 7,
        height: 4,
        width: 4,
        backgroundColor: baseColors.orange.dark
    }
})
